var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.26 30.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:#010101}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.13,
    cy: 15.13,
    r: 15.13,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.13 19.49a4.36 4.36 0 114.36-4.36 4.36 4.36 0 01-4.36 4.36zm0-7.27A2.91 2.91 0 1018 15.13a2.91 2.91 0 00-2.87-2.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.19 23.63h-8.12a4.43 4.43 0 01-4.43-4.44v-8.12a4.43 4.43 0 014.43-4.43h8.12a4.43 4.43 0 014.44 4.43v8.12a4.44 4.44 0 01-4.44 4.44zM11.07 8.09a3 3 0 00-3 3v8.12a3 3 0 003 3h8.12a3 3 0 003-3v-8.14a3 3 0 00-3-3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 19.62,
    cy: 10.57,
    r: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.326109cf2edf8f20e3266d5088b056c0.svg";
export { ForwardRef as ReactComponent };